import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { Button } from "@components/Button";
import { useCheckoutState } from "@hooks/useCheckout";
import { Waitlist } from "../Waitlist";
import { nodeToId } from "../lib/product-utils";
import styles from "./styles/footer.module.css";

function displayButton(loading, comingSoon, addToCart, variant, productTitle, waitlistMessage) {
  const { t } = useTranslation("sizeguide");

  if (!variant.availableForSale) {
    return (
      <Waitlist
        variantID={variant.id}
        variantTitle={variant.title}
        productTitle={productTitle}
        isComingSoon={comingSoon}
        waitlistMessage={waitlistMessage}
      />
    );
  }
  return (
    <Button
      handleClick={addToCart}
      isDisabled={loading || !variant.availableForSale}
      description="bag"
      descriptionText="Click to add to bag"
    >
      {loading ? t("adding") : t("add-to-bag-button")}
    </Button>
  );
}

export function Footer({ comingSoon = false, addToCart, variant, productTitle, waitlistMessage }) {
  const { loading } = useCheckoutState();
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {displayButton(loading, comingSoon, addToCart, variant, productTitle, waitlistMessage)}
      </div>
    </footer>
  );
}

Footer.propTypes = {
  loading: PropTypes.bool,
  comingSoon: PropTypes.bool,
  variant: PropTypes.object.isRequired,
  productTitle: PropTypes.string.isRequired,
  addToCart: PropTypes.func.isRequired,
  waitlistMessage: PropTypes.string,
};
